import AdminApi from '@/store/adminApi'
// import { Auth } from 'aws-amplify'

const user = {
  state: {
    members: null,
    stats: {
      members: {
        total: 0,
        unregistered: 0,
        board: 0,
        committeeActive: 0,
        committeeOptIn: 0
      }
    },
    filtered: null,
    filters: {
      text: null,
      type: null,
      pageNo: 0,
      pageCount: 20
    },
    memberItem: null,
    memberItemError: false
  },
  mutations: {
    setMembers: function (state, data) {
      state.members = data
    },
    setMemberStatus: function (state, data) {
      state.stats.members = data
    },
    setFilteredMembers: function (state, data) {
      state.filtered = data
    },
    setMemberItem: function (state, data) {
      state.memberItem = data
    },
    setMemberItemError: function (state, data) {
      state.memberItemError = data
    }
  },
  actions: {
    getMembers: async function (context) {
      console.log('ADMIN STORE - Get Member Index...')
      let response = await AdminApi.getMembers()
      console.log(response)
      if (response.users && !response.error) {
        let members = []
        let keys = Object.keys(response.users)

        for (var i = 0; i < keys.length; i += 1) {
          members.push(response.users[keys[i]])
        }

        console.log('ADMIN STORE - Index Retrieved!')
        context.commit('setMembers', members)
        context.commit('setFilteredMembers', members)
      }
    },
    getMemberStats: async function (context) {
      let response = await AdminApi.getMembers()
      if (response.users && !response.error) {
        let members = response.users

        let stats = {
          total: 0,
          registered: 0,
          active: 0,
          expired: 0,
          board: 0,
          committeeActive: 0,
          committeeOptIn: 0
        }

        let now = new Date().getTime()
        console.log('Do member status')
        let keys = Object.keys(members)
        for (var i = 0; i < keys.length; i += 1) {
          let item = members[keys[i]]
          stats.total += 1
          let current = item.membership.current || null
          if (current !== null) {
            stats.registered += 1
            let endDate = current.subscriptionEnds || null
            if (endDate && endDate >= now) stats.active += 1
            else stats.expired += 1
          } else stats.unregistered += 1

          if (item.executive && item.executive.active) stats.board += 1
          if (item.committee) {
            if (item.committee.optin) stats.committeeOptIn += 1
            if (item.committee.active) stats.committeeActive += 1
          }
        }

        context.commit('setMemberStatus', stats)
        return stats
      }

      return null
    },
    applyMemberFilters: async function (context, params) {
      console.log('Applying Member Filters')
      console.log(params)
      let args = {
        text: null,
        type: null,
        ...params
      }
      let members = context.state.members
      if (!args.text && !args.type) {
        console.log('Resetting Filters')
        context.commit('setFilteredMembers', members)
        return true
      }

      let filtered = []
      console.log('Searching Members')
      for (var i = 0; i < members.length; i += 1) {
        let member = members[i]
        let typeMatch = false
        let textMatch = false
        if (args.text) {
          let expr = new RegExp(args.text, 'i')

          if (
            expr.test(member.details.firstName) ||
            expr.test(member.details.lastName) ||
            expr.test(member.details.email)
          ) {
            textMatch = true
          }
        }

        if (args.type === 'all') typeMatch = true
        else {
          switch (args.type) {
            case 'member':
              if (member.membership.type === 'member') typeMatch = true
              break
            case 'life':
              if (member.membership.type === 'life') typeMatch = true
              break
            case 'committee':
              if (member.committee && member.committee.active) typeMatch = true
              break
            case 'executive':
              if (member.executive && member.executive.active) typeMatch = true
              break
          }
        }

        let setMember = false
        if (args.text && args.type) {
          if (textMatch && typeMatch) setMember = true
        }
        if (args.text && !args.type) {
          if (textMatch) setMember = true
        }
        if (!args.text && args.type) {
          if (typeMatch) setMember = true
        }

        if (setMember) filtered.push(member)
      }

      context.commit('setFilteredMembers', filtered)
      return true
    },
    adminLoadMember: async function (context, userId = null) {
      try {
        context.commit('setMemberItemError', false)
        context.commit('setMemberItem', null)

        const username = userId || null
        if (username && username !== null) {
          console.log('Retrieving Profile for User #' + userId)
          const response = await AdminApi.getMemberProfile(username)
          console.log('ApiCall Response')
          console.log(response)
          if (!response.error && response.profile) {
            let profile = response.profile
            profile.UserStatus = response.cognito.UserStatus
            profile.UserLastModifiedDate = response.cognito.UserLastModifiedDate
            profile.UserCreateDate = response.cognito.UserCreateDate
            context.commit('setMemberItem', response.profile)
          }
        }
      } catch (e) {
        console.log('AdminGetProfile Error')
        console.log(e)
        context.commit('setMemberItemError', true)
        return null
      }
    },
    adminUpdateProfile: async function (context, data) {
      console.log('Saving User Profile...')
      let response = await AdminApi.updateMemberProfile(data)
      if (!response.error && response.profile !== undefined) {
        console.log('Profile Saved!')
        console.log(response)
        let profile = response.profile
        profile.UserStatus = response.cognito.UserStatus
        profile.UserLastModifiedDate = response.cognito.UserLastModifiedDate
        profile.UserCreateDate = response.cognito.UserCreateDate
        context.commit('setMemberItem', response.profile)
        context.dispatch('refreshUser')
        return response.profile
      }

      console.log('UpdateProfile Error')
      console.log(response.error)
      return response
    },
    setTestMembers: async function (context, users) {
      console.log('Setting Test Members')
      console.log(users)
      context.commit('setMembers', users)
      context.commit('setFilteredMembers', users)
    },
    setMemberPage: async function (context, args) {
      console.log('Set Page No')
      console.log(args)

      let first = (args.pageNo - 1) * args.perPage
      let last = first + args.perPage
      context.commit(
        'setFilteredMembers',
        context.state.members.slice(first, last)
      )
    },
    adminGetCertificate: async function (context, data) {
      console.log('Admin API - Getting user Certificate')
      let response = await AdminApi.getCertificate(data)
      console.log('GetCertResponse')
      console.log(response)
      return response
    },
    promoteMember: async function (context, args) {
      try {
        console.log('ADMIN STORE - Promote Member Group')
        console.log(`Promoting User #${args.userid} to "${args.newTitle}"...`)
        let response = await AdminApi.promoteMember(args)
        console.log(response)
        if (response.error !== undefined) {
          console.log('PROMOTE ERROR')
          return { error: { message: response.error.message } }
        }

        console.log('PROMOTE SUCCESS')
        context.dispatch('getMembers')
        return response.capabilities
      } catch (e) {
        console.log('CATCH ERROR - Promote Member Group')
        console.log(e)
        return { error: { message: 'System Error' } }
      }
    },
    async adminGrantLife (context, args) {
      try {
        console.log('ADMIN STORE - Grant Life Membership')
        console.log('User: ', args.id)
        let response = await AdminApi.grantLifeMembership(args.id)
        console.log('Upgrade RESPONSE')
        console.log(response)
        if (response.error !== undefined) {
          console.log('Upgrade ERROR')
          return { error: response.error }
        }

        console.log('Upgrade SUCCESS')
        return { profile: response.profile }
      } catch (e) {
        console.log('API ERROR')
        console.log(e)
        return { error: e }
      }
    },
    async adminDeactivateMembership (context, args) {
      try {
        console.log('ADMIN STORE - Deactivate Active Membership')
        const username = args.userid
        console.log('User to Deactivate: ', username)
        const response = await AdminApi.deactivateMembership(username)
        console.log(response)
        if (response.error) {
          console.log('Deactivate Subscription ERROR')
          return { error: response.error }
        }

        console.log('Deactivate Subscription SUCCESS')
        return true
      } catch (e) {
        console.log('CATCH ERROR - Deactivate Active Membership')
        console.log(e)
        return { error: { message: 'API function Error' } }
      }
    },
    async resetMemberPwd (context, args) {
      try {
        console.log('ADMIN STORE - Reset User Pwd')
        const username = args.userid
        console.log('User to Reset: ', username)
        const response = await AdminApi.resetMemberPwd(username)
        console.log(response)
        if (response.error !== undefined) {
          console.log('Reset Password ERROR')
          return { error: response.error.message }
        }

        return response
      } catch (e) {
        console.log('CATCH ERROR - Reset User Password')
        console.log(e)
        return { error: { message: 'API function Error' } }
      }
    },
    async resendAccountActivation (context, args) {
      try {
        console.log('ADMIN STORE - Resend Activation Email')
        const username = args.userid
        console.log('User to Resend: ', username)
        const response = await AdminApi.resendAccountActivation(username)
        console.log(response)
        if (response.error !== undefined) {
          console.log('Resend Email ERROR')
          return { error: response.error.message }
        }

        return response
      } catch (e) {
        console.log('CATCH ERROR - Reset User Password')
        console.log(e)
        return { error: { message: 'API function Error' } }
      }
    },
    async updateMembers (context, args) {
      context.commit('setMembers', args.members)
    }
  },
  getters: {
    getMemberItem: function (state) {
      return state.memberItem
    },
    getMemberItemError: function (state) {
      return state.memberItemError
    },
    getTotalCount: function (state) {
      return state.members ? Object.keys(state.members).length : 0
    },
    getMembers: function (state) {
      return state.members
    },
    getMemberStats: function (state) {
      return state.stats.members
    },
    getFilteredMembers: function (state) {
      return state.filtered
    },
    getFilterCount: function (state) {
      return state.filtered ? Object.keys(state.filtered).length : 0
    }
  }
}

export default user
